import '../../style/base.css';



//////////////////
// WEBPACK FOOTER
// ./~/vant/es/collapse/style/index.js
// module id = 155
// module chunks = 0